import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import type { TagListResponse, TagMutationResponse } from '../models';
import { TagApi } from '../apis';

/**
 * Tag Service
 * Service layer that wraps the Tag API
 *
 * Responsibilities:
 * - Abstraction layer between components/stores and the HTTP layer
 * - Delegates tag listing, creation, and payment tag updates to TagApi
 */
@Injectable({
  providedIn: 'root',
})
export class TagService {
  private readonly tagApi = inject(TagApi);

  /**
   * Fetch all available tags for the merchant.
   */
  listTags(): Observable<TagListResponse> {
    return this.tagApi.listTags();
  }

  /**
   * Create a new tag under the merchant account.
   */
  createTag(tagName: string): Observable<TagMutationResponse> {
    return this.tagApi.createTag(tagName);
  }

  /**
   * Update the complete tag list for a specific payment.
   * Sends the full final set of tags — the API reconciles adds and removes.
   */
  updatePaymentTags(paymentId: string, tags: string[]): Observable<TagMutationResponse> {
    return this.tagApi.updatePaymentTags(paymentId, tags);
  }
}
